<template>
  <div class="home" @mouseenter="mouseEnter" @mousemove="mouseMove" @mouseleave="mouseLeave">
    <br/>
    <div v-if="messages.length > 0">
      <div v-for="message in messages" :key="message._id">
        <div class="messages">
          <div class="box message">
            <div class="message-header">
              <p class="is-size-7">
                <span>
                  <span v-if="message.level === 'livegame'"><i class="fas fa-bullseye"></i></span>
                  <span v-if="message.level === 'warning'"><i class="fas fa-skull-crossbones"></i></span>
                  <span v-if="message.level === 'feature'"><i class="fas fa-crow"></i></span>
                  <span v-if="message.level === 'information'"><i class="fas fa-info"></i></span>
                  <span v-if="message.level === 'reminder'"><i class="fas fa-bell"></i></span>
                  <span v-if="message.level === 'bug'"><i class="fas fa-bug"></i></span>
                </span>
                <span>{{ message.title }}</span>
              </p>
            </div>
            <div>
              <p class="is-size-6">{{ message.description }}</p>  
              <p class="is-size-6" v-if="message.level === 'livegame'"><a href="https://axes2.ca/display" target="new">View</a></p>
              <p style="font-size: 0.6em;">{{ message.start_date }}</p>  
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <img :src="`${publicPath}img/Axes2-poster.png`"/>
      <br/>
      <div v-if="!$auth.isAuthenticated" class="has-text-centered has-text-danger">
        <p class="is-size-5">
          <a @click="login" class="sign-in"><strong>&gt;&gt; Sign-in here &lt;&lt;</strong></a>
        </p>
      </div>
    </div>
    <!--
    <p>
      <a @click="sendTestPhoto" class="button">send test photo</a>
    </p>
    -->
    <div v-if="$auth.isAuthenticated" class="has-text-centered has-text-danger">
      <p class="is-size-5">
        <a @click="startThrowing" class="sign-in"><strong>&gt;&gt; Start Throwing &lt;&lt;</strong></a>
      </p>
    </div>

    <br/>
    <br/>
    <!--
    <div class="worlds">
      <br/>
      <p class="is-size-6">2022 Championship scorecards are <router-link to="/worlds">here</router-link>.</p>
      <br/>
    </div>
    -->
    <br/>
    <br/>
    <br/>

  </div>
</template>

<script>
//import EventsList from '../components/EventsList';
//import router from '../router'
import axios from "axios";
import moment from 'moment';

export default {
  name: 'home',
  data () {
    return {
        debugMode: (process.env.VUE_APP_DEBUG_MODE === "true" ? true : false),
        publicPath: process.env.BASE_URL,
        messages: [],
        playing: false
    }
  },
  methods: {
    sendTestPhoto() { 
      //
      //
      var photo_data = '';
      //
      this.sendPhotoControlMessage('photo',photo_data,'Dartmouth - Lane 2 - Darren Hudson');
      //
      //
      //
      //
    },
    sendPhotoControlMessage(control_type, control_value, title) {
      this.$parent.submitPhotoControl('{ "control_type": "' + control_type + '", "control_value": "' + control_value + '", "title" : "' + title + '" }');
    },

    // Log the user in
    login() {
        this.$auth.loginWithRedirect();
    },
    startThrowing() {
      this.$router.push('throw');
    },
    getMessages() {
     // console.log("getting broadcast messages");
      var today = new moment().utc();
      //console.log("today: " + today);
      var end = today;
      var start = end.clone().subtract(7, "days");
      //console.log("start: " + start.format('YYYY-MM-DDTHH:mm:ss'));
      //console.log("end: " + end.format('YYYY-MM-DDTHH:mm:ss'));
      
      var url = (this.debugMode ? "http://localhost:8080/current_messages" : "https://axes2api.azurewebsites.net/current_messages")
      url += "/" + start.format('YYYY-MM-DDTHH:mm:ss') + "/" + end.format('YYYY-MM-DDTHH:mm:ss');

      this.messages = [];

      axios.get(url)
        .then((response) => {
         // console.log("...got broadcast messages.")
          this.messages = response.data; 
        }, (error) => {
          console.log("...error getting broadcast messages.")
          //console.log("error retrieving broadcast messages")
        });
    },
    mouseEnter(event) {
      //console.log('mouseneter');
      //this.play();
    },
    mouseLeave(event) {
    },
    mouseMove(event) {
    },
    updateProfile: function(profile) {
      var url = (this.debugMode ? "http://localhost:8080/auto_update_profile" : "https://axes2api.azurewebsites.net/auto_update_profile")
      url += "/" + profile.email;
      var token = this.$parent.getApiToken();
      axios.patch(url, 
        {
          profile: profile
        },
        {
          headers: {
              authorization: token
            }
        }
      );
    },
  },
  components: {
    //EventsList
  },
  mounted(){
    this.getMessages();

    setTimeout(() => {
      //console.log("isAuthenticated?", this.$auth.isAuthenticated);
      //console.log("$auth", this.$auth.user);
      if (this.$auth.isAuthenticated) {

        const d = new Date().UTC;
        var ten_minutes_ago = new moment(d).subtract(1,"minutes");
        
        var updated_date = new  moment.utc(this.$auth.user.updated_at);
        
        //console.log("ten_minutes_ago",ten_minutes_ago);
        //console.log("updated_date",updated_date);

        //if the auth.user.updated_at is recent (last ten minutes)
        if (updated_date > ten_minutes_ago) {
          this.updateProfile(this.$auth.user);
        }
      }
    }, 2000);

  }
}

</script>

<style lang="scss" scoped>
  .worlds {
    color: goldenrod;
  }
  .sign-in {
    color: yellow;
    font-size: 0.8em;    
  }
  img {
    max-width: 100%;
    height: auto;
  }

  @media screen and (min-width: 600px) {
    img {
      width: 50%;
    }
  }
  .messages {
    max-width: 350px; 
    margin: auto;
  }
  .message {
    border-radius: 10px;
    background-color: white; 
    margin-bottom: 10px;
    padding: 5px;
  }
  .message-header {
    border-radius: 10px;
    width: 100%;
  }

  @media screen and (min-width: 600px) {
  }
  .home {
      font-family: Verdana;
      background-color: #181313;
      text-align: center;
  }
</style>